<!-- @format -->
<div class="dialog-max cdialog" style="max-width: 300px">
  <div class="dialogHeader">
    <h2 mat-dialog-title>{{ _common.export_booking }}</h2>
    <div class="spacer"></div>

    <div (click)="onCancel()" class="closeButton">
      <fa-icon icon="times"></fa-icon>
    </div>
  </div>

  <mat-dialog-content>
    <div class="dialogBody">
      <form
        [formGroup]="form"
        class="flex flex-col gap-2 items-center text-center"
      >
        <div>
          {{ _common.export_booking_desc }}
        </div>

        <app-form-field class="w-full md:w-[250px]">
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate formControlName="start" />
            <input matEndDate formControlName="end" />
          </mat-date-range-input>
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </app-form-field>

        <div>
          <mat-slide-toggle formControlName="checkinTime">{{
            _common.export_booking_incl_checkin
          }}</mat-slide-toggle>
          <div
            *ngIf="form.value.checkinTime"
            class="text-red-500 text-sm mt-2"
          >
            {{ _common.export_booking_incl_checkin_alrt }}
          </div>
        </div>
      </form>
    </div>
  </mat-dialog-content>

  <div class="dialogBar">
    <div class="spacer"></div>
    <button class="app-btn" (click)="save()" color="primary">
      {{ _common.export }}
    </button>
  </div>
</div>
